// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__31Qsd","tab":"Tabs_tab__zS1mj","tabActive":"Tabs_tabActive__2dCoU"};